export var ConfigManagerCommand;
(function (ConfigManagerCommand) {
    ConfigManagerCommand["loadManufacturers"] = "config_manager.load_manufacturers";
    ConfigManagerCommand["lookupManufacturer"] = "config_manager.lookup_manufacturer";
    ConfigManagerCommand["loadDeviceIndex"] = "config_manager.load_device_index";
    ConfigManagerCommand["getIndex"] = "config_manager.get_index";
    ConfigManagerCommand["loadFulltextDeviceIndex"] = "config_manager.load_fulltext_device_index";
    ConfigManagerCommand["getFulltextIndex"] = "config_manager.get_fulltext_index";
    ConfigManagerCommand["lookupDevice"] = "config_manager.lookup_device";
    ConfigManagerCommand["lookupDevicePreserveConditions"] = "config_manager.lookup_device_preserve_conditions";
    ConfigManagerCommand["manufacturers"] = "config_manager.manufacturers";
    ConfigManagerCommand["loadAll"] = "config_manager.load_all";
    ConfigManagerCommand["configVersion"] = "config_manager.config_version";
})(ConfigManagerCommand || (ConfigManagerCommand = {}));
